<template id="quizList">
    <v-ons-page>
         <div class="text-center" style="margin-top: 50px;" v-if="initialLoad">
            <v-ons-progress-circular v-if="initialLoad" style="border-radius: 50%; height: 40px; width: 40px;" indeterminate></v-ons-progress-circular>
            <span v-if="initialLoad"  style="border-radius: 50%; height: 40px; width: 40px;">...</span>
            <span v-else class="colorBlue">&nbsp;</span>
        </div>
        <v-ons-toolbar class="toolbarBack">
            <div class="left">
                <!--                <v-ons-toolbar-button @click="$router.push('/quiz')" class="back-icon"></v-ons-toolbar-button>-->
               <v-ons-toolbar-button class="back-icon" style="margin: unset; margin-left: 10px; width: 0px !important;" @click="goBack()"></v-ons-toolbar-button>
            </div>
            <div class="center toolbar-alignMent">
                <div>
                    <img class="verticallyMiddle" alt="quiz-image" src="../assets/hamropatro.png"
                         style="width: 22px;height: 22px"/>
                </div>
                &nbsp;<div class="predictWinWrapper">{{text.taliWaGali}}</div>
            </div>
            <div class="right" v-if="isLogin && activeQuiz || quizLists">
                <v-ons-toolbar-button class="chat-icon" @click="$router.push('/chat/'+userId)"></v-ons-toolbar-button>
                <v-ons-toolbar-button class="more-vert" @click="showDrawer=!showDrawer"></v-ons-toolbar-button>
            </div>
            <div v-else-if="isLogin" class="right">
                <v-ons-toolbar-button class="refresh" @click="refresh()"></v-ons-toolbar-button>
                <v-ons-toolbar-button class="more-vert" @click="showDrawer=!showDrawer"></v-ons-toolbar-button>
            </div>
        </v-ons-toolbar>
        <div>
            <v-ons-pull-hook
                    :action="loadItem"
                    @changestate="state = $event.state"
            >
                <span v-show="state === 'initial'">
                    <v-ons-progress-circular class="refreshButton circularPad"
                                             value="20"></v-ons-progress-circular>
                </span>
                <span v-show="state === 'preaction'">
                    <v-ons-progress-circular class="refreshButton circularPad"
                                             value="40"></v-ons-progress-circular>
                </span>
                <span v-show="state === 'action'">
                    <v-ons-progress-circular class="refreshButton circularPad"
                                             value="100"></v-ons-progress-circular>
                </span>
            </v-ons-pull-hook>
            <v-ons-toast :visible.sync="showSnack">
                {{snackBarMsg}}
                <button @click="showSnack = false"><i class="zmdi zmdi-close"></i>
                </button>
            </v-ons-toast>
            <p class="text-center">
                <v-ons-progress-circular class="refreshButton" indeterminate
                                         v-if="loading && loadingActive"></v-ons-progress-circular>
            </p>
            <div v-if="isLogin && showDrawer">
                <UserDrawer v-bind:userDetails="userDetails"/>
            </div>
            <div style="margin: 0 15px" v-if="lastQuizId" @click="pushToWinners(lastQuizId,'previous-winners')">
                <img src="https://creative.hamropatro.com/img/talai_gali_banner.jpg" alt="winners-list" class="winnerImageCard">
            </div>
            <!-- Message Box not logged in-->
            <v-ons-card class="historyCard paddingNone text-center" v-if="!isLogin && (activeQuiz || quizLists)" @click="$router.push('/login')">
                <div class="quizTime">
                    <div class="colorWhite timeStartEnd">{{text.withoutLoginMSG}}
                    </div>
                </div>
            </v-ons-card>

            <!-- Active Quiz -->
            <v-ons-card v-if="activeQuiz" class="paddingNone activeCard" @click="pushTo(activeQuiz.data.key,activeQuiz.data.question,'activeQues-viewed')">
                <div class="imgWrapper169">
                    <img :src="activeQuiz.data.image" alt="quiz-image" class="quizImage169">
                    <span class="top-right active">{{text.active}}</span>

                </div>
                <div class="padding12px">
                    <div>
                        <div class="historyTitle colorBlack">
                            <span>{{activeQuiz.data.title}}</span>
                            <!--                            <small>({{activeQuiz.data.type}})</small>-->
                        </div>
                    </div>
                    <button class="button--large--cta currentButton">{{text.voteNow}}</button>
                </div>
            </v-ons-card>

            <!-- Message Box-->
            <v-ons-card class="historyCard paddingNone" v-if="isLogin && (activeQuiz || quizLists)">
                <div class="quizTime">
                    <div class="colorWhite timeStartEnd">{{text.messages}}
                    </div>
                </div>
                <div class="colorWhite text-center">
                    <div class="detailPage" style="margin-bottom: 0" @click="$router.push('/chat/'+userId)">
                        <div class="text-center font14px" v-if="chatData===false">
                            <p class="colorWhite" style="padding: 40px 10px">{{text.msgText}}</p>
                        </div>
                        <div v-if="chatData===true" class="chat-room--list pa-3" style="overflow-y:auto" id="scroll-chat">
                            <template v-for="(value, key,index) in chatMessages">
                                <div v-if="index>=Object.keys(chatMessages).length-2" v-bind:class="[ value.sender.userID === userId ? 'reverse' : '']" class="messaging-item layout row my-4" :key="key">
                                    <div class="v-avatar mx-1" style="width: 30px; height: 30px">
                                        <img :src="value.sender.img" alt="" v-if="value.sender.img" class="" style="">
                                        <span v-else>{{firstLetter(value.sender.name)}} {{index}}</span>
                                    </div>
                                    <div class="" style="max-width: 70%;margin: 0 5px 5px; ">
                                        <p :value="true" v-bind:class="[ value.sender.userID === userId ? 'userStyle' : 'nonUser']" class="colorWhite" style="font-size:15px;line-height:1.3;height:auto; padding: 10px 15px !important; margin: 0 0 5px;" >
                                            {{value.msg}}
                                        </p>
                                        <div v-bind:class="[ value.sender.userID === userId ? 'clearBoth chatDate colorWhite floatRight' : 'clearBoth chatDate colorWhite floatLeft']">{{new Date(Number(key)).toLocaleString()}}</div>
                                    </div>
                                </div>
                            </template>
                            <div style="margin: 10px 0;padding: 15px 0 5px;border-top: 1px solid #e5e5e5;">
                                <div class="font10px">{{text.viewAll}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-ons-card>

            <!-- History Quiz -->
            <v-ons-card class="paddingNone historyCard"
                        v-for="(item) in quizLists" @click="pushTo(item.key,item.question,'history-viewed')">
                <div class="imgWrapper169">
                    <img :src="item.image" alt="quiz-image" class="quizImage169">
                    <span class="top-right closed">{{text.closed}}</span>
                </div>
                <div class="padding12px">
                    <div>
                        <div class="historyTitle colorWhite">
                            <span>{{item.title}}</span>
                            <!--                            <small>({{item.type}})</small>-->
                        </div>
                    </div>
                    <button class="button--large--cta resultButton" v-if="item.status=='Result'">{{text.viewResult}}</button>
                    <button class="button--large--cta resultButton" v-if="item.status=='Completed'">{{text.viewDetails}}
                    </button>
                </div>
            </v-ons-card>
            <div v-if="cursorValue!==''">
                <p class="text-center">
                    <v-ons-progress-circular class="refreshButton" indeterminate
                                             v-if="loadItems"></v-ons-progress-circular>
                </p>
                <v-ons-button @click="getMoreItems(cursorValue)" modifier="large" class="loadMore">
                    {{text.loadMore}}
                </v-ons-button>
            </div>
        </div>
    </v-ons-page>

</template>

<script>
    import {getActiveQuiz, getQuizHistory} from '../api/requests/questions';
    import {getChatMessage} from '../api/requests/chat';
    // import {user_authentication} from '../util/user_authentication';
    // import {getUserID, getUserInfo, isLogin} from '../util/globalConfig';
    import UserDrawer from "../components/UserDrawer";
    import {trigetGoogleAnaystEvent} from "../config";
    import usedText from "../util/languageText";
    import { Miniapp } from '../util/Miniapp';

    export default {
        name: 'QuizList',
        components: {UserDrawer},
        data: () => ({
            // forSnackbar
            showSnack: null,
            snackBarMsg: null,
            allQuizItems: [],
            quizLists: [],
            loading: false,
            loadingActive: false,
            loadItems: false,
            cursorValue: '',
            isActiveQuiz: [],
            activeQuiz: null,
            lastQuizId:'',
            state: 'initial',
            chatMessages: null,
            chatData:null,
            userId: null,
            showDrawer:false,
            userDetails: null,
            isLogin: false,
            text:usedText,
            initialLoad: true
        }),
        async created() {
            let self = this;
            const userDetails  = await Miniapp.getUserProfile();
            self.userDetails = userDetails;
            self.userId = userDetails != null ? userDetails.id : null;
            self.isLogin = userDetails.id != '';
            this.getItems();
            self.initialLoad = false;
            sessionStorage.removeItem('loginStarted');
        },
        methods: {
            async getItems() {
                this.getHistory('');
                this.getActive();
                if(await Miniapp.getUserProfile())
                    this.chatConversation();

                //remove snackBar
                let self = this;
                setTimeout(function () {
                    self.showSnack = false;
                }, 2000);
            },
            getHistory: function (cursor) {
                let self = this;
                self.loading = true;
                self.showSnack = false;
                self.quizLists = '';
                self.cursorValue = '';
                self.lastQuizId = '';
                getQuizHistory(cursor).then(function (response) {
                    self.loading = false;
                    if (response.success) {
                        if (response.data.length <= 0) {
                            // show SnackBar
                            // self.snackBarMsg = 'Empty Question List';
                            // self.showSnack = true;
                        }
                        self.allQuizItems = response;
                        self.quizLists = response.data;
                        self.cursorValue = response.cursor;
                        self.lastQuizId = response.lastresultkey;

                    } else {
                        // show SnackBar
                        // self.snackBarMsg = response.msg;
                        // self.showSnack = true;
                    }
                }).catch(function (error) {
                    self.loading = false;
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            getActive: function () {
                let self = this;
                self.loadingActive = true;
                self.showSnack = false;
                self.activeQuiz = '';
                getActiveQuiz().then(function (response) {
                    self.loadingActive = false;
                    if (response.success) {
                        self.activeQuiz = response;
                    }
                    // else {
                    //     // show SnackBar
                    //     self.snackBarMsg = response.msg;
                    //     self.showSnack = true;
                    // }
                }).catch(function (error) {
                    self.loadingActive = false;
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
            },
            chatConversation () {
                let self = this;
                self.showSnack = false;
                if(self.userId) {
                    getChatMessage(self.userId).then(function (response) {
                        if (response.success) {
                            self.chatMessages = response.data;
                            self.chatData=true;
                        } else {
                            // show SnackBar
                            self.chatData=false;
                            // self.snackBarMsg = response.msg;
                            // self.showSnack = true;
                        }
                    }).catch(function (error) {
                        self.chatData=false;
                        // show SnackBar
                        // self.snackBarMsg = error.data.msg;
                        // self.showSnack = true;
                    });
                }
                
            },
            getMoreItems: function (cursor) {
                let self = this;
                self.loadItems = true;
                self.showSnack = false;
                getQuizHistory(cursor).then(function (response) {
                    self.loadItems = false;
                    if (response.success) {
                        if (response.data.length <= 0) {
                            // show SnackBar
                            // self.snackBarMsg = 'Empty Question List';
                            // self.showSnack = true;
                        }
                        self.cursorValue = response.cursor;
                        self.quizLists = self.quizLists.concat(response.data);
                    } else {
                        self.loadItems = false;
                        // show SnackBar
                        // self.snackBarMsg = response.msg;
                        // self.showSnack = true;
                    }
                }).catch(function (error) {
                    self.loadItems = false;
                    // show SnackBar
                    // self.snackBarMsg = error.data.msg;
                    // self.showSnack = true;
                });
                //remove snackBar
                setTimeout(function () {
                    self.showSnack = false;
                }, 2000);
            },
            pushTo(key,question,event){
                    trigetGoogleAnaystEvent(question,'quizDetail',event);
                    this.$router.push('/'+key+'/detail')
            },
            pushToWinners(quizId,event){
                if (Miniapp.getIsLoggedIn()) {
                    trigetGoogleAnaystEvent(quizId, 'quizWinners', event);
                    this.$router.push('/' + quizId + '/winners');
                } else this.$router.push('/login');
            },
            refresh () {
                this.getItems();
            },
            goBack() {
                if(Miniapp.getIsMobileDevice()) {
                    Miniapp.exitMiniApp();
                }
            },
            firstLetter(title) {
                return title.charAt(0);
            },
            loadItem(done) {
                setTimeout(() => {
                    this.loading = true;
                    this.getItems();
                    done();
                }, 500);
            },
            logout() {
                Miniapp.logout();
            }
        },
    };
</script>
